var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDrums = function SvgDrums(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    vectorEffect: "non-scaling-stroke",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M6.848 7.253a1.875 1.875 0 1 0 3.75 0 1.875 1.875 0 1 0-3.75 0m.547-1.324L1.712 1.487m11.885 5.901a1.875 1.875 0 1 0 3.75 0 1.875 1.875 0 1 0-3.75 0m3.255-1.27 5.856-4.212m-.53 10.079H1.502m-.21 10.498 20.996.03m-19.495-.03 4.708-10.378 4.289 10.393 4.709-10.513 4.289 10.528M2.793 11.985v10.498m17.995-10.468v10.498"
  })));
};
export default SvgDrums;